import { format, parseISO } from "date-fns";
import { money } from "../lib/api";
import { SafeImg } from "./SafeImg";

const Item = ({ label, children, testid }) => (
  <div><p className="eyebrow">{label}</p><p className="mt-1 text-ink" data-testid={testid}>{children}</p></div>
);

export const ReservationSummary = ({ res }) => {
  const q = res.quote;
  const d = (s) => format(parseISO(s), "EEE, d MMM yyyy");
  return (
    <div className="overflow-hidden rounded-3xl border border-brand/10 bg-white" data-testid="reservation-summary">
      <div className="relative h-48">
        <SafeImg src={q.hotel.image} alt={q.hotel.name} compact className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-shade/80 to-transparent" />
        <div className="absolute bottom-5 left-6">
          <p className="font-serif text-3xl text-paper">{q.hotel.name}</p>
          <p className="text-sm text-paper/80">{q.hotel.address}</p>
        </div>
      </div>
      <div className="grid gap-6 p-6 sm:grid-cols-3 [&>*]:min-w-0 [overflow-wrap:anywhere]">
        <Item label="Reference" testid="reservation-ref"><span className="font-mono text-lg">{res.ref}</span></Item>
        <Item label="Status" testid="reservation-status"><span className="capitalize">{res.status}</span></Item>
        <Item label="Guest" testid="reservation-guest">{res.guest.title} {res.guest.first_name} {res.guest.last_name}</Item>
        <Item label="Arrival">{d(res.arrival)}</Item>
        <Item label="Departure">{d(res.departure)}</Item>
        <Item label="Rooms">{q.rooms} × {q.room.name}</Item>
        <Item label="Rate">{q.rate.name}</Item>
        <Item label="Guests / room">{res.adults} adults{res.kids ? `, ${res.kids} kids` : ""}</Item>
        <Item label="Total" testid="reservation-total"><span className="font-mono text-lg">{money(q.total, q.currency)}</span></Item>
        {res.payment && (
          <Item label="Balance" testid="reservation-balance">
            {res.balance > 0 ? `${money(res.balance, q.currency)} due ${d(res.balance_due)}` : "Fully paid"}
          </Item>
        )}
        {res.balance_payment && (
          <Item label="Balance payment" testid="reservation-balance-payment">
            {money(res.balance_payment.amount, res.balance_payment.currency)} via M-Pesa
            {res.balance_payment.mode === "simulated" ? " (demo, not paid)" : ` · ${res.balance_payment.receipt}`}
          </Item>
        )}
        {res.payment && (
          <Item label={res.balance > 0 ? "Deposit" : "Paid"} testid="reservation-deposit">
            {money(res.payment.amount, res.payment.currency)} via {res.payment.method}
            {res.payment.mode === "simulated" ? " (demo, not paid)" : ` · ${res.payment.receipt}`}
          </Item>
        )}
      </div>
      {q.services.length > 0 && (
        <div className="border-t border-ink/10 px-6 py-4 text-sm text-ink/70">
          Services: {q.services.map((s) => `${s.name} ×${s.qty}`).join(", ")}
        </div>
      )}
    </div>
  );
};
